import React, { useEffect, useState, useRef } from "react";
import axiosClient from "../axiosClient";
import axiosClientSevan from "../axiosClientSevan";
import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  TextField,
  Button,
  Alert,
} from "@mui/material";

import { useStateContext } from "../context/ContextProvider";

const AddStoreScreen = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const storeNameRef = useRef();
  const storeAddressRef = useRef();
  const storeZipRef = useRef();
  const storeTelephoneRef = useRef();
  const resellerRef = useRef();

  const [preview, setPreview] = useState();
  const [change, onChange] = useState();

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const { setToken } = useStateContext();

  useEffect(() => {
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        setToken(response.data.accessToken);
        setCompanies(response.data.customer);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSave = () => {
    var base64Data;
    var binaryData;

    if (preview === null || preview === undefined) {
      base64Data = null;
      binaryData = null;
    } else {
      base64Data = preview?.split(",")[1]; // Extract the Base64 data
      binaryData = atob(base64Data);
    }

    const storePayload = {
      params: {
        storeName: storeNameRef.current.value,
        address: storeAddressRef.current.value,
        zip: storeZipRef.current.value,
        license_date_expiration: new Date(), // this is the free trial how many days of free trial they have, currenlty they dont have
        activeLicense: true,
        telephone: storeTelephoneRef.current.value,
        logo: binaryData,
        storeBillId: 0,
        CompanyId: selectedCompany,
        resellerCode: resellerRef.current.value,
      },
    };

    const selectedCompanyObject = companies.filter(
      (comp) => comp.id == selectedCompany
    );

    axiosClient
      .post("customer/company/store/create", storePayload)
      .then((response) => {
        setErrorMessage("");

        const storeId = response.data.storeId;

        const payloadSevan = {
          company_code: selectedCompanyObject[0].company_bill_id,
          shop_name: storeNameRef.current.value,
          service_id: 301,
          platform_name: "SOFTECH"
        };

        axiosClientSevan
          .post("api/create/shop", payloadSevan)
          .then((response) => {
            const payload_bill = {
              params: {
                id: storeId,
                store_bill_id: parseInt(response.data.data.shop_code),
              },
            };

            axiosClient
              .patch("customer/store/bill", payload_bill)
              .then(() => {
                setSuccessMessage("Data save successfully.");
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              })
              .catch((err) => console.log(err));
          });
      })
      .catch((err) => {
        const errorMessage = err.response.data.err.errors.map((e) => {
          return (
            <>
              {e.message}
              <br></br>
            </>
          );
        });
        setErrorMessage(errorMessage);
      });
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <FormControl fullWidth>
            <InputLabel id="type">Companies</InputLabel>
            <Select
              autoFocus
              labelId="type"
              label="Company"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setSelectedCompany(e.target.value);
              }}
            >
              {companies.map((company) => (
                <MenuItem value={company.id}>{company.company_name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {successMessage && (
          <Alert severity="success" sx={{ marginBottom: 2, marginTop: 2 }}>
            {successMessage}
          </Alert>
        )}
      </Grid>
      <Grid item xs={12}>
        {errorMessage && (
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {errorMessage}
          </Alert>
        )}
      </Grid>
      <Box m={4} />
      {selectedCompany && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store name"
              fullWidth
              inputRef={storeNameRef}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store address"
              fullWidth
              inputRef={storeAddressRef}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store zip"
              fullWidth
              inputRef={storeZipRef}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store telephone"
              fullWidth
              inputRef={storeTelephoneRef}
            />
          </Grid>
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Reseller code"
              fullWidth
              inputRef={resellerRef}
            />
          </Grid>
          <Grid item xs={12} lg={6} md={6} sm={6}>
            <div className="image-input-container">
              <input
                type="file"
                accept=".jpg"
                onChange={handleChange}
                className="input-file"
              />
              {preview && (
                <img src={preview} alt="Preview" className="preview-image" />
              )}
              {!preview && (
                <div className="placeholder">Click to select an image</div>
              )}
            </div>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 16,
            }}
          >
            <Button
              variant="contained"
              color="success"
              style={{ marginRight: 16, marginLeft: 16 }}
              onClick={handleSave}
            >
              Add store
            </Button>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default AddStoreScreen;
